import type { Lead_Agents } from '@graphql/__generated__/graphql';

export const sortBySourceThenCreatedAt = (
  la1: Pick<Lead_Agents, 'source' | 'created_at'>,
  la2: Pick<Lead_Agents, 'source' | 'created_at'>,
) => {
  const firstWeight = la1.source === 'result_page' ? 1 : 0;
  const secondWeight = la2.source === 'result_page' ? 1 : 0;

  return (
    firstWeight - secondWeight ||
    new Date(la2.created_at).getTime() - new Date(la1.created_at).getTime()
  );
};
